import moment from 'moment';

// services
import { DoctorService } from '@/services/doctor.service';

// utils
import { formatCurrency } from '@/utils';

// constants
import { TEST_DOCTOR_ID } from '@/constants/doctors';
import EarningSearch from '@/components/doctors/EarningSearch';
export default {
  components: {
    EarningSearch
  },
  props: {
    currentFilter: {
      type: String,
      default: 'Month to Date'
    },
    hideZeroValues: {
      type: Boolean,
      default: false
    },
    showInactiveDoctors: {
      type: Boolean,
      default: false
    },
    hideV1Earnings: {
      type: Boolean,
      default: false
    },
    excludeTestData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      allHeaders: [{
        key: 'doctor',
        label: 'Doctor',
        sortable: true,
        formatter: (key, value, item) => {
          return `${item.firstname} ${item.lastname}`;
        },
        sortByFormatted: true
      }, {
        key: 'billing-period',
        label: 'Billing Period',
        sortable: true
      }, {
        key: 'new-patients',
        label: 'New Patients'
      }, {
        key: 'transferred-patients',
        label: 'Transferred Patients'
      }, {
        key: 'message-adjusted',
        label: 'Messaged Patients (Adjusted)'
      }, {
        key: 'ten-week-followups',
        label: '10 Week Follow Ups'
      }, {
        key: 'one-year-followups',
        label: '1 Year Follow Ups'
      }, {
        key: 'total-followups',
        label: 'Total Follow Ups'
      }, {
        key: 'grand-total-v1',
        label: 'Grand Total v1'
      }, {
        key: 'total-unique-patients-interaction',
        label: 'Total Unique Patients Interaction'
      }, {
        key: 'grand-total-v2',
        label: 'Grand Total v2'
      }, {
        key: 'grand-total-v2-california',
        label: 'Grand Total V2 (California)'
      }, {
        key: 'grand-total-v2-new-jersey',
        label: 'Grand Total V2 (New Jersey)'
      }, {
        key: 'grand-total-v2-excluding-ca-nj',
        label: 'Grand Total V2 (Excluding CA & NJ)'
      }],
      items: [],
      nextPage: ''
    };
  },
  computed: {
    v1ColumnKeys() {
      return ['transferred-patients', 'grand-total-v1'];
    },
    headers() {
      if (!this.hideV1Earnings) {
        return this.allHeaders;
      }
      return this.allHeaders.filter(h => !this.v1ColumnKeys.includes(h.key));
    },
    searchResults() {
      return this.$store.state.earnings.searchResults;
    },
    filteredItems() {
      const items = this.excludeTestData ? this.items.filter(item => item.doctorid !== TEST_DOCTOR_ID) : this.items;
      return this.hideZeroValues ? items.filter(item => item.earning.total > 0) : items;
    },
    totals() {
      let totalPatients = 0;
      let totalTransferPatients = 0;
      let totalPatientsMessageAdjusted = 0;
      let totalTenWeek = 0;
      let totalOneYear = 0;
      let grandTotal = 0;
      let totalFollowups = 0;
      let totalUniquePatientsInteraction = 0;
      let grandTotalV2 = 0;
      let grandTotalV2California = 0;
      let grandTotalV2NewJersey = 0;
      let grandTotalV2ExcludingCaNj = 0;
      this.filteredItems.forEach(item => {
        grandTotal += item.earning.total || 0;
        totalPatients += item.patients.new || 0;
        totalTransferPatients += item.patients.transferfollowup || 0;
        totalPatientsMessageAdjusted += item.earning.v2.all.patientMessages || 0;
        totalTenWeek += item.patients.followuptenweek || 0;
        totalOneYear += item.patients.followuponeyear || 0;
        totalFollowups += item.patients.followup || 0;
        totalUniquePatientsInteraction += item.earning.v2.all.totalInteractions || 0;
        grandTotalV2 += item.earning.v2.all.totalInteractions * item.earning.v2.all.price || 0;
        grandTotalV2California += item.earning.v2.ca.totalInteractions * item.earning.v2.ca.price || 0;
        grandTotalV2NewJersey += item.earning.v2.nj.totalInteractions * item.earning.v2.nj.price || 0;
        grandTotalV2ExcludingCaNj += item.earning.v2.non_ca_nj.totalInteractions * item.earning.v2.non_ca_nj.price || 0;
      });
      const totals = {
        grandTotal,
        totalPatients,
        totalTransferPatients,
        totalPatientsMessageAdjusted,
        totalTenWeek,
        totalOneYear,
        totalFollowups,
        totalUniquePatientsInteraction,
        grandTotalV2,
        grandTotalV2California,
        grandTotalV2NewJersey,
        grandTotalV2ExcludingCaNj
      };
      return totals;
    }
  },
  watch: {
    searchResults() {
      if (this.searchResults.length == 0) {
        this.getEarning(this.$store.state.earnings.from, this.$store.state.earnings.to);
      } else {
        this.items = this.searchResults;
      }
    },
    showInactiveDoctors() {
      // Refetch data when toggle changes
      this.getEarning(this.$store.state.earnings.from, this.$store.state.earnings.to);
    },
    async currentFilter(val) {
      const currentMonth = moment().format('YYYYMM');
      if (val == 'Last Month') {
        const lastMonth = moment().subtract(1, 'months').format('YYYYMM');
        this.$store.commit('earnings/SET_STATE', {
          from: lastMonth,
          to: lastMonth
        });
        return this.getEarning(lastMonth, lastMonth);
      }
      if (val == 'Month to Date') {
        this.$store.commit('earnings/SET_STATE', {
          from: currentMonth,
          to: currentMonth
        });
        return this.getEarning(currentMonth, currentMonth);
      }
      if (val == 'Year to Date') {
        const startOfYear = moment().startOf('year').format('YYYYMM');
        this.$store.commit('earnings/SET_STATE', {
          from: startOfYear,
          to: currentMonth
        });
        return this.getEarning(startOfYear, currentMonth);
      }
      if (val == 'All Time') {
        // ? Jan 2021 - Earliest possible month
        const start = '202101';
        this.$store.commit('earnings/SET_STATE', {
          from: start,
          to: currentMonth
        });
        return this.getEarning(start, currentMonth);
      }
    }
  },
  async mounted() {
    const currentMonth = moment().format('YYYYMM');
    this.$store.commit('earnings/SET_FILTER_FROM', currentMonth);
    this.$store.commit('earnings/SET_FILTER_TO', currentMonth);
    this.getEarning(currentMonth, currentMonth);
  },
  methods: {
    formatCurrency,
    async getEarning(start, end) {
      const {
        data
      } = await DoctorService.getDoctorEarning(start, end, null, this.showInactiveDoctors);
      this.items = data;
      if (data.nextpage) {
        this.nextPage = data.nextpage;
      }
    },
    getBillingPeriodString(month, year) {
      const startOfMonth = moment(`${year}-${month}`).startOf('month').format('MM/DD/YYYY');
      const endOfMonth = moment(`${year}-${month}`).endOf('month').format('MM/DD/YYYY');
      return `${startOfMonth} - ${endOfMonth}`;
    }
  }
};